import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Dashboard from './views/Dashboard.vue'
import Integrations from './views/Integrations.vue'
import Logout from './views/login/Logout.vue'

import LoginContainer from './views/login/Container.vue'
import LoginLogin from './views/login/Login.vue'
import LoginSignup from './views/login/Signup.vue'
import LoginDemo from './views/login/Demo.vue'
import LoginRouter from './views/login/Router.vue'

import OnboardingContainer from './views/onboarding/Container.vue'
import OnboardingWelcome from './views/onboarding/Welcome.vue'
import OnboardingVideo from './views/onboarding/Video.vue'
import OnboardingVoice from './views/onboarding/Voice.vue'
import OnboardingWait from './views/onboarding/Wait.vue'

import AppContainer from './views/AppContainer.vue'

import AdminContainer from './views/admin/Container.vue'
import Admin from './views/admin/Admin.vue'
import Users from './views/admin/Users.vue'
import Search from './views/admin/Search.vue'
import QualityControl from './views/admin/QualityControl.vue'
import WebsiteRecorder from './views/admin/WebsiteRecorder.vue'

import SettingsContainer from './views/settings/Container.vue'
import Settings from './views/settings/Settings.vue'
import Team from './views/settings/Team.vue'
import Billing from './views/settings/Billing.vue'

import VoiceContainer from './views/voices/Container.vue'
import VoiceList from './views/voices/List.vue'
import VoiceView from './views/voices/View.vue'
import VoiceCreate from './views/voices/Create.vue'
import VoiceEdit from './views/voices/Edit.vue'
import VoiceTrain from './views/voices/Train.vue'

import ProjectContainer from './views/projects/Container.vue'
import ProjectList from './views/projects/List.vue'
import ProjectView from './views/projects/View.vue'
import ProjectCreate from './views/projects/Create.vue'
import ProjectEdit from './views/projects/Edit.vue'
import ProjectIntegrate from './views/projects/Integrate.vue'
import ProjectTune from './views/projects/Tune.vue'
import ProjectQualityControl from './views/projects/QualityControl.vue'

import ProjectItemList from './views/projects/items/List.vue'
import ProjectItemView from './views/projects/items/View.vue'
import ProjectItemCreate from './views/projects/items/Create.vue'
import ProjectItemBatchCreate from './views/projects/items/BatchCreate.vue'
import ProjectItemEdit from './views/projects/items/Edit.vue'

import SequenceContainer from './views/sequences/Container.vue'
import SequenceList from './views/sequences/List.vue'
import SequenceView from './views/sequences/View.vue'
import SequenceCreate from './views/sequences/Create.vue'
import SequenceEdit from './views/sequences/Edit.vue'

import RecipientList from './views/sequences/recipients/List.vue'
import RecipientView from './views/sequences/recipients/View.vue'
import RecipientCreate from './views/sequences/recipients/Create.vue'
import RecipientBatchCreate from './views/sequences/recipients/BatchCreate.vue'
import RecipientEdit from './views/sequences/recipients/Edit.vue'

import ImageTemplateContainer from './views/image_templates/Container.vue'
import ImageTemplateList from './views/image_templates/List.vue'
import ImageTemplateView from './views/image_templates/View.vue'
import ImageTemplateCreate from './views/image_templates/Create.vue'
import ImageTemplateEdit from './views/image_templates/Edit.vue'
import ImageTemplateIntegrate from './views/image_templates/Integrate.vue'

import ImageTemplateImageList from './views/image_templates/images/List.vue'
import ImageTemplateImageView from './views/image_templates/images/View.vue'
import ImageTemplateImageBatchCreate from './views/image_templates/images/BatchCreate.vue'
import ImageTemplateImageEdit from './views/image_templates/images/Edit.vue'

import Error from './views/Error.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {path: '/', name: 'home', component: Home},
    {path: '/logout', name: 'logout', component: Logout},

    {path: '/login', component: LoginContainer, children: [
      {path: '', name: 'login_router', component: LoginRouter},
      {path: 'login', name: 'login_login', component: LoginLogin},
      {path: 'account_signup', name: 'login_signup', component: LoginSignup},
      {path: 'demo', name: 'login_demo', component: LoginDemo},
    ]},
    {path: '/onboarding', component: OnboardingContainer, children: [
      {path: '', name: 'onboarding_welcome', component: OnboardingWelcome},
      {path: 'video', name: 'onboarding_video', component: OnboardingVideo},
      {path: 'voice', name: 'onboarding_voice', component: OnboardingVoice},
      {path: 'wait', name: 'onboarding_wait', component: OnboardingWait},
    ]},
    {path: '', component: AppContainer, children: [
      {path: 'dashboard', name: 'dashboard', component: Dashboard},
      {path: 'integrations', name: 'integrations', component: Integrations},
      {path: '/voices', component: VoiceContainer, children: [
        {path: '', name: 'voices', component: VoiceList},
        {path: 'create', name: 'voice_create', component: VoiceCreate},
        {path: ':id', name: 'voice', component: VoiceView},
        {path: ':id/edit', name: 'voice_edit', component: VoiceEdit},
        {path: ':id/train', name: 'voice_train', component: VoiceTrain},
      ]},
      {path: '/projects', component: ProjectContainer, children: [
        {path: '', name: 'projects', component: ProjectList},
        {path: 'quality_control', name: 'projects_quality_control', component: ProjectQualityControl},
        {path: 'create', name: 'project_create', component: ProjectCreate},
        {path: ':id/edit', name: 'project_edit', component: ProjectEdit},
        {path: ':id/integrate', name: 'project_integrate', component: ProjectIntegrate},
        {path: ':id/tune', name: 'project_tune', component: ProjectTune},
        {path: ':id', component: ProjectView, children: [
          {path: '', name: 'project', component: ProjectItemList},
          {path: 'create', name: 'item_create', component: ProjectItemCreate},
          {path: 'batch_create', name: 'item_batch_create', component: ProjectItemBatchCreate},
          {path: ':item', name: 'item', component: ProjectItemView},
          {path: ':item/edit', name: 'item_edit', component: ProjectItemEdit},
        ]},
      ]},
      {path: '/image_templates', component: ImageTemplateContainer, children: [
        {path: '', name: 'image_templates', component: ImageTemplateList},
        {path: 'create', name: 'image_template_create', component: ImageTemplateCreate},
        {path: ':id/edit', name: 'image_template_edit', component: ImageTemplateEdit},
        {path: ':id/integrate', name: 'image_template_integrate', component: ImageTemplateIntegrate},
        {path: ':id', component: ImageTemplateView, children: [
          {path: '', name: 'image_template', component: ImageTemplateImageList},
          {path: 'create', name: 'image_create', component: ProjectItemCreate},
          {path: 'batch_create', name: 'image_batch_create', component: ImageTemplateImageBatchCreate},
          {path: ':item', name: 'image', component: ImageTemplateImageView},
          {path: ':item/edit', name: 'image_edit', component: ImageTemplateImageEdit},
        ]},
      ]},
      {path: '/sequences', component: SequenceContainer, children: [
        {path: '', name: 'sequences', component: SequenceList},
        {path: 'create', name: 'sequence_create', component: SequenceCreate},
        {path: ':id/edit', name: 'sequence_edit', component: SequenceEdit},
        {path: ':id', component: SequenceView, children: [
          {path: '', name: 'sequence', component: RecipientList},
          {path: 'create', name: 'recipient_create', component: RecipientCreate},
          {path: 'batch_create', name: 'recipient_batch_create', component: RecipientBatchCreate},
          {path: ':recipient', name: 'recipient', component: RecipientView},
          {path: ':recipient/edit', name: 'recipient_edit', component: RecipientEdit},
        ]},
      ]},
      {path: '/settings', component: SettingsContainer, children: [
        {path: '', name: 'settings', component: Settings},
        {path: 'team', name: 'team', component: Team},
        {path: 'billing', name: 'billing', component: Billing},
      ]},
      {path: '/admin', component: AdminContainer, children: [
        {path: '', name: 'admin', component: Admin},
        {path: 'users', name: 'users', component: Users},
        {path: 'search', name: 'search', component: Search},
        {path: 'quality_control', name: 'quality_control', component: QualityControl},
        {path: 'website_recorder', name: 'website_recorder', component: WebsiteRecorder},
      ]},
    ]},
    {path: '*', component: Error}
  ]
})
